import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { TextField } from '@mui/material';
import { Grid } from '@mui/material';
import APIService from '../../../../APIService';
import swal from 'sweetalert';

export default function SACMinutes() {

  const [sacMinutes, setSacMinutes] = useState([]);
  const [description, setDescription] = useState("");
  const [year, setYear] = useState("");
  const [fileUpload, setFileUpload] = useState("");

  const [sacMinutesId, setSacMinutesId] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    APIService.get('sac_minutes').then((response) => {
      setSacMinutes(response.data);
    })
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFileUpload(e.target.files[0]);
    }
  }

  const changePosition = (direction, itemId) => {

    APIService.post([], `change-position/${direction}/sac_minutes/${itemId}`)
      .then((response) => {
        // console.log(response);
        if (response.success) {
          APIService.get('sac_minutes').then((response) => {
            setSacMinutes(response.data);
          });
        }
      })
  }

  const handleEdit = (itemId, year, description) => {

    setSacMinutesId(itemId);
    setIsEditing(true);
    setYear(year);
    setDescription(description);
  }

  const handleDelete = (itemId) => {

    // e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You want to delete this item?",
      icon: "warning",
      dangerMode: true,
    })
      .then(willDelete => {
        if (willDelete) {
          APIService.delete(`sac_minutes/${itemId}`)
            .then(response => {
              swal("Success", response.message, "success", {
                buttons: false,
                timer: 2000,
              }).then((value) => {
                window.location.href = "/sac_minutes";
              });
            });
        }
      });
  }


  const handleSubmit = async (e) => {

    e.preventDefault();
    const formData = new FormData();
    formData.append("description", description);
    formData.append("year", year);
    formData.append("file_upload", fileUpload);

    if (isEditing) {
      var response = await APIService.put(formData, `sac_minutes/${sacMinutesId}`);
    } else {
      var response = await APIService.post(formData, 'sac_minutes');
    }

    if (response.success) {

      swal("Success", response.message, "success", {
        buttons: false,
        timer: 2000,
      }).then((value) => {

        window.location.href = "/sac_minutes";
      });
    } else {

      swal("Failed", response.message, "error");
    }
  }

  return (
    <div>
      <h3 className='heading'>SAC Minutes</h3>

      <form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Year</p>
            <TextField
              type="number"
              name="year"
              label="Year"
              variant="outlined"
              fullWidth
              value={year}
              onChange={e => setYear(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Upload File</p>
            <TextField
              name="upload-photo"
              type="file"
              onChange={handleFileChange}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={12} md={8}>
            <p id="labels">Description</p>
            <TextField
              fullWidth
              id="outlined-multiline-static"
              label="Description"
              multiline
              rows={3}
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>

        <Button style={{ marginTop: 20 }} variant="primary" type="submit" >Submit</Button>{' '}
      </form>

      <div className="minutes-tab">
        <Table striped bordered hover variant="light">
          <thead>
            <tr>
              <th className='table-no-aling'>Sr.No. </th>
              <th>Description</th>
              <th>Year</th>
              <th>Edit</th>
              <th>Delete</th>
              <th>Move Up</th>
              <th>Move Down</th>
            </tr>
          </thead>
          <tbody>

            {sacMinutes.map((minute, index) => (
              <tr key={minute.id}>
                <td>{index + 1}</td>
                <td>{minute.description}</td>
                <td>{minute.year}</td>
                <td >
                  <Button variant="success" onClick={() => handleEdit(minute.id, minute.year, minute.description)}>Edit</Button>
                </td>
                <td >
                  <Button variant="danger" onClick={() => handleDelete(minute.id)}>Delete</Button>
                </td>
                <td>
                  <button className='move-btn'
                    onClick={() => changePosition("up", minute.id)}
                  ><img width="32" height="32" src="https://img.icons8.com/external-kmg-design-glyph-kmg-design/32/external-up-arrow-arrows-kmg-design-glyph-kmg-design.png" alt="external-up-arrow-arrows-kmg-design-glyph-kmg-design" /></button>
                </td>
                <td>
                  <button className='move-btn'
                    onClick={() => changePosition("down", minute.id)}
                  ><img width="36" height="40" src="https://img.icons8.com/fluency-systems-filled/48/thick-arrow-pointing-down.png" alt="thick-arrow-pointing-down" /></button>
                </td>
              </tr>
            ))}

          </tbody>
        </Table>
      </div>
    </div>
  )
}
